import React from 'react';
import PropTypes from 'prop-types';
import CircularProgress from '@material-ui/core/CircularProgress';

const overlayStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: 'rgba(255, 255, 255, 0.8)',
  zIndex: 9999,
};

const inlineStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '24px',
};

const messageStyle = {
  marginTop: '16px',
  color: '#666',
  fontSize: '14px',
};

const Loading = ({ fullScreen, message }) => {
  const containerStyle = fullScreen ? overlayStyle : inlineStyle;

  return (
    <div style={containerStyle}>
      <CircularProgress color="primary" />
      {message && <p style={messageStyle}>{message}</p>}
    </div>
  );
};

Loading.propTypes = {
  fullScreen: PropTypes.bool,
  message: PropTypes.string,
};

Loading.defaultProps = {
  fullScreen: false,
  message: null,
};

export default Loading;
